export function generateAdvanceFilterQuery(data: any) {
  const filtersArray: any[] = [];

  for (const [key, value] of Object.entries(data)) {
    if (value !== "" && value !== null) {
      let filterObj = {
        column: [key],
        operator: "CONTAINS",
        value: value,
        logicalOperator: "AND",
      };

      if (key === "transaction_date") {
        filterObj.value = value + "-";
      }

      filtersArray.push(filterObj);
    }
  }

  if (filtersArray.length > 0) {
    const encoded = encodeURIComponent(JSON.stringify(filtersArray, null, 2));
    return `advanceFilter=${encoded}`;
  }

  return "";
}
